import React, { useContext, useEffect, useState } from "react";
import { FaRegCalendarAlt, FaRegClock, FaSun, FaMoon } from "react-icons/fa";
import { basic_panchang } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import { GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import dayjs from "dayjs";
import Breadcrumbs from "../../Breadcrumb";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from '../../../assets/images/new/newLogo.jpg'
import sunrise from '../../../assets/images/new/sunrise.png'
import sunset from '../../../assets/images/new/sunset-.png'
import moonset from '../../../assets/images/new/moonset.png'
import moonrise from '../../../assets/images/new/moonrise.png'
import { LoaderContext } from "../../../AuthContext/AuthContext";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import Numerology from "../../../assets/images/new/services1 (3).jpg";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import { useLocation, useNavigate } from "react-router-dom";
import customParseFormat from "dayjs/plugin/customParseFormat";
const DailyPanchang = () => {
  dayjs.extend(customParseFormat);
  const [animate, setAnimate] = useState(false);
  const { setLoader, pujaStatus, fetchedLocation, timezoneOffset } = useContext(LoaderContext);
  const [panchangDetails, setPanchangDetailsObj] = useState({
    Name: null,
    tithi_name: null,
    nak_name: null,
    yog_name: null,
    karan_name: null,
    rahukaalStart: null, rahukaalEnd: null, gulikaalStart: null, gulikaalEnd: null, yamghandkaalStart: null, yamghandkaalEnd: null,
    sunrise: null, sunSet: null, moonRise: null, moonSet: null,
    data: null, date: null
  });
  const [otherDetails, setOtherDetailsObj] = useState([]);
  const navigate = useNavigate()
  const location = useLocation()
  const categories = [
    {
      title: "Astrology",
      image: Astro,
      icon: astrology,
      text: "Book Astrology for your spiritual rituals and ceremonies.",
      color: "#ffa415",
      route: "/basic-details",
    },
    {
      title: "Panchang",
      image: Panchang,
      icon: panchang,
      text: "Get a Panchang for your up and down ",
      color: "#fc5528",
      route: "/daily-panchang",
    },
    {
      title: "Numerology",
      image: Numerology,
      icon: numerology,
      text: "Numerology for better life",
      color: "#8139e7",
      route: "/numerology",
    },
    {
      title: "Zodiac Signs",
      image: Prediction,
      icon: zodiacSign,
      text: "Know about Prediction",
      color: "#399be7",
      route: "/Prediction ",
    }

  ];





  useEffect(() => {
    GetUserModelData();
    setTimeout(() => {
      setAnimate(true);
    }, 300); // Delay animation to make it smoother
  }, []);

  const GetUserModelData = async () => {
    setLoader(true);

    const userID = JSON.parse(localStorage.getItem("userID"));
    try {
      const response = await GetUserModel(userID);
      if (response?.ResponseCode == 0) {
        setLoader(false);
        const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData[0]?.DOB);
        const today = new Date();

        const year = today.getFullYear();
        const month = today.getMonth() + 1; // Months are zero-based
        const day = today.getDate();

        setPanchangDetailsObj((prev) => ({ ...prev, Name: ModelData[0]?.FULL_NAME }))


        const [hours, minutes] = ModelData[0]?.BIRTH_TIME.split(":");
        const apiParam = {
          day: day,
          month: month,
          year: year,
          hour: hours,
          min: minutes,
          lat: fetchedLocation?.lat,
          lon: fetchedLocation?.lon,
          tzone: timezoneOffset,
        };
        await GetBasicPanchangData(
          apiParam,
          dayjs(day).format("DD/MM/YYYY")
        );
      } else {
        setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };

  const convertTo12Hour = (timeString) => {
    // Parse with fallback to "HH:mm:ss" format
    const parsed = dayjs(timeString, "H:m:s"); // handles 1-digit hours/mins too
    return parsed.isValid() ? parsed.format("hh:mm A") : "Invalid time";
  };


  const GetBasicPanchangData = async (apiParam, DATE) => {
    setLoader(true);
    try {
      const response = await basic_panchang(apiParam);
      if (response !== null && response !== undefined) {
        setLoader(false);
        setPanchangDetailsObj((prev) => ({
          ...prev,
          tithi_name: response?.tithi?.details?.tithi_name,
          nak_name: response?.nakshatra?.details?.nak_name,
          yog_name: response?.yog?.details?.yog_name,
          karan_name: response?.karan?.details?.karan_name,

          rahukaalStart: convertTo12Hour(response?.rahukaal?.start),
          rahukaalEnd: convertTo12Hour(response?.rahukaal?.end),
          gulikaalStart: convertTo12Hour(response?.guliKaal?.start),
          gulikaalEnd: convertTo12Hour(response?.guliKaal?.end),
          yamghandkaalStart: convertTo12Hour(response?.yamghant_kaal?.start),
          yamghandkaalEnd: convertTo12Hour(response?.yamghant_kaal?.end),

          sunrise: convertTo12Hour(response?.sunrise),
          sunSet: convertTo12Hour(response?.sunset),
          moonRise: convertTo12Hour(response?.moonrise),
          moonSet: convertTo12Hour(response?.moonset),
          day: response?.day,
          date: dayjs().format('DD/MM/YYYY')
        }));



      } else {
        setLoader(false);
        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };


  return (
    <>
      <section className="page-header" style={{ paddingBottom: '30px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">Daily Panchang</h2>
          <div >
            <Breadcrumbs />
          </div>
        </div>
      </section>

      <div className="container pt-4">
        {/* Mobile horizontal scroll */}
        <div className="d-flex d-md-none overflow-auto px-2">
          {categories.map((category, index) => (
            <div
              key={index}
              className="text-center me-3 flex-shrink-0"
              style={{ width: "100px", cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>

        {/* Desktop grid layout */}
        <div className="row justify-content-center text-center g-4 d-none d-md-flex">
          {categories.map((category, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-2"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`${category?.route}`)}
            >
              <div
                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                style={{ width: "70px", height: "70px" }}
              >
                <img
                  src={category.icon}
                  alt={category.title}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <p
                className="mt-2 fw-semibold"
                style={{
                  color:
                    category?.route === location?.pathname
                      ? "#a52444"
                      : "#212529",
                }}
              >
                {category.title}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="container-fluid mt-2 p-0 w-100"

      >

        {/* Top Section: Two Cards Per Row & Panchang Table */}
        <div className="row px-1"  >
          {/* Left Side: Two Cards Per Row */}
          <div className={`col-md-5 p-3 ${animate ? "slide-in-left" : "opacity-0"}`}  >

            <div className="row">
              <div className="col-md-6 mb-3s  " >
                <div className="glass-card p-3 text-center panchangCard" style={{ justifyContent: 'space-around' }}>
                  <h6 className="text-uppercase ">
                    <span className=" horoscopeFont"> Date</span>
                  </h6>
                  <p className="mb-0  horoscopeFont">{panchangDetails?.date}</p>
                </div>
              </div>
              <div className="col-md-6 mb-3" >
                <div className="glass-card p-3 text-center panchangCard" style={{ justifyContent: 'space-around' }}>
                  <h6 className="text-uppercase ">
                    <span className="horoscopeFont "> Day</span>
                  </h6>
                  <p className="mb-0 horoscopeFont ">{panchangDetails?.day}</p>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="glass-card p-3 d-flex align-items-center gap-3 panchangCard" style={{ justifyContent: 'space-around' }}>
                  <img src={sunrise} width={40} height={40} alt="Sunrise" />

                  <div>
                    <h6 className="text-uppercase mb-1">
                      <span className=" horoscopeFont">Sunrise</span>
                    </h6>
                    <p className="mb-0  horoscopeFont">{panchangDetails?.sunrise}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="glass-card p-3 d-flex align-items-center gap-3 panchangCard" style={{ justifyContent: 'space-around' }}>
                  <img src={sunset} width={40} height={40} alt="Sunrise" />

                  <div>
                    <h6 className="text-uppercase mb-1">
                      <span className=" horoscopeFont">Sunset</span>
                    </h6>
                    <p className="mb-0  horoscopeFont">{panchangDetails?.sunSet}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3" >
                <div className="glass-card p-3 d-flex align-items-center gap-3 panchangCard" style={{ justifyContent: 'space-around' }}>
                  <img src={moonrise} width={40} height={40} alt="Moonrise" />
                  <div>
                    <h6 className="text-uppercase mb-1">
                      <span className=" horoscopeFont">Moonrise</span>
                    </h6>
                    <p className="mb-0 horoscopeFont ">{panchangDetails?.moonRise}</p>
                  </div>

                </div>
              </div>
              <div className="col-md-6 mb-3" >
                <div className="glass-card p-3 d-flex align-items-center gap-3 panchangCard" style={{ justifyContent: 'space-around' }}>
                  <img src={moonset} width={40} height={40} alt="Moonrise" />
                  <div>
                    <h6 className="text-uppercase ">
                      <span className=" horoscopeFont"> Moonset</span>
                    </h6>
                    <p className="mb-0  horoscopeFont">{panchangDetails?.moonSet}</p>
                  </div>


                </div>
              </div>
            </div>


          </div>
          {/* Right Side: Panchang Table */}
          <div className={`col-12 col-md-7 mb-4 ${animate ? "slide-in-left" : "opacity-0"}`}>
            <div className="glass-card p-3 h-100">
              <h5 className="text-center mb-3 fw-bold horoscopeHeaderFont">PANCHANG DETAILS</h5>
              <table className="table table-sm">
                <tbody>
                  {/* Row 1 - Name and Tithi */}
                  <tr className="d-block d-md-table-row">
                    <td className="horoscopeFont">Name</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.Name}</td>

                    <td className="ps-4 horoscopeFont d-none d-md-table-cell">Tithi</td>
                    <td className="d-none d-md-table-cell">:</td>
                    <td className="text-start horoscopeFont d-none d-md-table-cell">{panchangDetails?.tithi_name}</td>
                  </tr>
                  <tr className="d-block d-md-none">
                    <td className="horoscopeFont">Tithi</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.tithi_name}</td>
                  </tr>

                  {/* Row 2 - Yog and Nakshatra */}
                  <tr className="d-block d-md-table-row">
                    <td className="horoscopeFont">Yog</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.yog_name}</td>

                    <td className="ps-4 horoscopeFont d-none d-md-table-cell">Nakshtra</td>
                    <td className="d-none d-md-table-cell">:</td>
                    <td className="text-start horoscopeFont d-none d-md-table-cell">{panchangDetails?.nak_name}</td>
                  </tr>
                  <tr className="d-block d-md-none">
                    <td className="horoscopeFont">Nakshtra</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.nak_name}</td>
                  </tr>

                  {/* Repeat this pattern for all rows */}
                  <tr className="d-block d-md-table-row">
                    <td className="horoscopeFont">Karan</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.karan_name}</td>

                    <td className="ps-4 horoscopeFont d-none d-md-table-cell">Rahukaal Start</td>
                    <td className="d-none d-md-table-cell">:</td>
                    <td className="text-start horoscopeFont d-none d-md-table-cell">{panchangDetails?.rahukaalStart}</td>
                  </tr>
                  <tr className="d-block d-md-none">
                    <td className="horoscopeFont">Rahukaal Start</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.rahukaalStart}</td>
                  </tr>

                  {/* Continue similarly for rest */}
                  <tr className="d-block d-md-table-row">
                    <td className="horoscopeFont">Rahukaal End</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.rahukaalEnd}</td>

                    <td className="ps-4 horoscopeFont d-none d-md-table-cell">Gulikaal Start</td>
                    <td className="d-none d-md-table-cell">:</td>
                    <td className="text-start horoscopeFont d-none d-md-table-cell">{panchangDetails?.gulikaalStart}</td>
                  </tr>
                  <tr className="d-block d-md-none">
                    <td className="horoscopeFont">Gulikaal Start</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.gulikaalStart}</td>
                  </tr>

                  <tr className="d-block d-md-table-row">
                    <td className="horoscopeFont">Gulikaal End</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.gulikaalEnd}</td>

                    <td className="ps-4 horoscopeFont d-none d-md-table-cell">Yamghand Kaal Start</td>
                    <td className="d-none d-md-table-cell">:</td>
                    <td className="text-start horoscopeFont d-none d-md-table-cell">{panchangDetails?.yamghandkaalStart}</td>
                  </tr>
                  <tr className="d-block d-md-none">
                    <td className="horoscopeFont">Yamghand Kaal Start</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.yamghandkaalStart}</td>
                  </tr>

                  <tr className="d-block d-md-table-row">
                    <td className="horoscopeFont">Yamghand Kaal End</td>
                    <td>:</td>
                    <td className="text-start horoscopeFont">{panchangDetails?.yamghandkaalEnd}</td>


                  </tr>

                </tbody>
              </table>

            </div>
          </div>
        </div>


      </div>
    </>
  );
};

export default DailyPanchang;
